import Guest from "@/types/clients/esquire/data/general/contract-data/guest";

export default class UpdateGuestPayload {
  public reservationId: string;
  public guest: Guest;

  constructor(guest: Guest, reservationId: string) {
    this.reservationId = reservationId as string;
    this.guest = guest as Guest;
  }

  toJson(){
    return {
      reservation_id: this.reservationId,
      guest: this.guest.toJson()
    }
  }
}
